import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  ...theme.paddings(0),
  gap: 0,
  backgroundColor: theme.palette.white,
  borderRadius: 10,
  border: "1px solid rgba(37, 99, 235, 0.3)",
  overflow: "hidden",
}));

export const BlockTitle = styled("h3")(({ theme }) => ({
  fontSize: 18,
  fontWeight: 600,
  color: theme.palette.text.primary,
  padding: "20px 24px",
  borderBottom: `1px solid ${theme.palette.border.light}`,
  margin: 0,

  [theme.down("sm")]: {
    fontSize: 16,
    padding: "15px 15px",
  },
}));

export const RoutesWrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  gap: 0,
  width: "100%",
}));
